import React from 'react';
import { LayersIcon } from 'lucide-react';
const links = [{
  label: 'Términos de Servicio',
  href: '#terminos'
}, {
  label: 'Política de Privacidad',
  href: '#privacidad'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Footer() {
  return <footer className="w-full bg-blue-50 py-14 md:py-16" data-id="element-102" data-mp="32m1bozwzl2p5">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-103" data-mp="36q9354utwwr2">
        <p className="inline-flex items-center gap-2 font-display text-lg font-extrabold uppercase tracking-[0.14em] text-blue-600" data-id="element-104" data-mp="3ueih5klswg7n">
          <LayersIcon className="h-5 w-5" aria-hidden="true" data-id="element-105" data-mp="387ejk1577e7" />
          Atlas Kinesio-Visual
        </p>

        <p className="mx-auto mt-5 max-w-xl text-blue-900/75" data-id="element-106" data-mp="3le2icog05x94">
          Material digital | Acceso inmediato | Garantía de satisfacción 7 días
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-blue-900/75" data-id="element-107" data-mp="29ynjtg85axbw">
          {links.map(link => <li key={link.label} data-id="element-108" data-mp="2ezl3xycpu1g1">
              <a href={link.href} className="transition-colors duration-150 ease-calm hover:text-blue-600" data-id="element-109" data-mp="3l9k7bh9idvfe">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-10 border-t border-blue-100 pt-6 text-sm text-blue-900/50" data-id="element-110" data-mp="3v8hqs5s2uyrj">
          © 2026 Atlas Kinesio-Visual. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}